import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
//primereact
import { SelectButton } from "primereact/selectbutton";
import { Accordion, AccordionTab } from "primereact/accordion";
//components
import Resume from "./Resume";
import ModalClientData from "../../../components/payment/ModalClientData";
import ModalPixPayment from "../../../components/payment/ModalPixPayment";
import CreditCard from "../../../components/payment/CreditCard";
import PaymentMethods from "../../../components/payment/PaymentMethods";
//services
import { getDueDate } from "../../../services/CreateAccount/getDueDate";
//context
import { useCreateAccountContext } from "../../../context/CreateAccountContext";

const Payment = () => {
  const formPix = useForm();
  const navigate = useNavigate();
  const [optionsDays, setOptionsDays] = useState([]);
  const [loadingCupom, setLoadingCupom] = useState(false);
  const [visibleDiscount, setVisibleDiscount] = useState(false);
  const [activeIndexModal, setActiveIndexModal] = useState(0);
  const [visibleCreditCard, setVisibleCreditCard] = useState(false);
  const [optionsInstallments, setOptionsInstallments] = useState([]);
  const [visibleModalCreditCard, setVisibleModalCreditCard] = useState(false);

  const {
    form,
    plan,
    cupom,
    bestDay,
    setCupom,
    cardState,
    pixClient,
    pixDataQR,
    setBestDay,
    cardMonthly,
    baseDataForm,
    setPixDataQR,
    handleSubmit,
    setPixClient,
    typeInterval,
    appliedCoupon,
    loadingButton,
    validateCupom,
    paymentMethod,
    setCardMonthly,
    cardInstallment,
    handleInputFocus,
    setPaymentMethod,
    creditCardClient,
    handleInputChange,
    visiblePixPayment,
    setCardInstallment,
    handleMonthlyFocus,
    creditCardSelected,
    handleMonthlyChange,
    setCreditCardClient,
    setVisiblePixPayment,
    visiblePaymentMethods,
    setCreditCardSelected,
    handleInstallmentFocus,
    handleInstallmentChange,
    setVisiblePaymentMethods,
  } = useCreateAccountContext();

  const { data: dueDates } = useQuery({
    queryKey: ["dueDate"],
    queryFn: () => getDueDate(),
  });

  const handleSelectPaymentMethod = (value) => {
    setVisiblePaymentMethods(false);
    setPaymentMethod(value);
  };

  const templateDays = (option) => {
    return <h5>{option.value}</h5>;
  };

  const onSubmitPix = (data) => {
    setPixClient(data);
    setVisiblePaymentMethods(true);
    form.setValue("installments", null);
  };

  useEffect(() => {
    if (dueDates) {
      const newOptions = dueDates.map((d) => ({
        value: d.due_date,
      }));
      setOptionsDays(newOptions);
    }
  }, [dueDates]);

  useEffect(() => {
    if (plan) {
      // console.log(plan);
      const newOptions = [];
      for (
        let i = 1;
        i <= plan.interval.pivot.installments_subscription_fee;
        i++
      ) {
        newOptions.push({
          label: `X ${i} Meses`,
          value: i,
        });
      }
      setOptionsInstallments(newOptions);
    }
  }, [plan]);

  useEffect(() => {
    if (pixClient) {
      formPix.setValue("customer_name", pixClient.customer_name);
      formPix.setValue("customer_email", pixClient.customer_email);
      formPix.setValue("customer_doc", pixClient.customer_doc);
      formPix.setValue("phone_pix", pixClient.phone_pix);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pixClient]);

  return (
    <>
      <div className="my-5">
        <div className="row justify-content-around">
          <div
            className={`col-xl-6 col-md-7 ${
              typeInterval.type !== "month" ? "my-auto" : ""
            }`}
            style={
              typeInterval.type !== "month" ? { height: "fit-content" } : {}
            }
          >
            {typeInterval.type === "month" ? (
              <Accordion activeIndex={0}>
                <AccordionTab header="Adesão">
                  <PaymentMethods
                    pix
                    card
                    installment
                    form={form}
                    formPix={formPix}
                    cardState={cardState}
                    onSubmitPix={onSubmitPix}
                    paymentMethod={paymentMethod}
                    setCardMonthly={setCardMonthly}
                    cardInstallment={cardInstallment}
                    setPaymentMethod={setPaymentMethod}
                    handleInputFocus={handleInputFocus}
                    creditCardClient={creditCardClient}
                    handleInputChange={handleInputChange}
                    visibleCreditCard={visibleCreditCard}
                    setCardInstallment={setCardInstallment}
                    handleMonthlyFocus={handleMonthlyFocus}
                    creditCardSelected={creditCardSelected}
                    setActiveIndexModal={setActiveIndexModal}
                    setCreditCardClient={setCreditCardClient}
                    optionsInstallments={optionsInstallments}
                    setVisibleCreditCard={setVisibleCreditCard}
                    setCreditCardSelected={setCreditCardSelected}
                    visiblePaymentMethods={visiblePaymentMethods}
                    handleInstallmentFocus={handleInstallmentFocus}
                    handleInstallmentChange={handleInstallmentChange}
                    setVisiblePaymentMethods={setVisiblePaymentMethods}
                    setVisibleModalCreditCard={setVisibleModalCreditCard}
                    handleSelectPaymentMethod={handleSelectPaymentMethod}
                  />
                </AccordionTab>
                <AccordionTab header="Mensalidade">
                  <>
                    <div className="d-flex flex-column text-center justify-content-center mb-5">
                      <h4>Qual o melhor dia do mês para sua mensalidade?</h4>
                      <SelectButton
                        value={bestDay}
                        onChange={(e) => setBestDay(e.value)}
                        itemTemplate={templateDays}
                        optionLabel="value"
                        options={optionsDays}
                      />
                    </div>
                    {/* {bestDay && (
                      <CreditCard
                        completed={paymentMethod !== "pix"}
                        state={cardMonthly}
                        handleInputChange={handleMonthlyChange}
                        handleInputFocus={handleMonthlyFocus}
                        onClickData={() => {
                          setVisibleModalCreditCard(true);
                          setActiveIndexModal(0);
                        }}
                        onClickAddress={() => {
                          setVisibleModalCreditCard(true);
                          setActiveIndexModal(1);
                        }}
                        clientData={
                          creditCardClient?.data && creditCardClient?.data
                        }
                        clientAddress={
                          creditCardClient?.address && creditCardClient?.address
                        }
                      />
                    )} */}
                  </>
                </AccordionTab>
              </Accordion>
            ) : (
              <div className="h-100">
                <PaymentMethods
                  pix
                  card
                  installment
                  form={form}
                  formPix={formPix}
                  cardState={cardState}
                  onSubmitPix={onSubmitPix}
                  paymentMethod={paymentMethod}
                  setCardMonthly={setCardMonthly}
                  cardInstallment={cardInstallment}
                  setPaymentMethod={setPaymentMethod}
                  handleInputFocus={handleInputFocus}
                  creditCardClient={creditCardClient}
                  handleInputChange={handleInputChange}
                  visibleCreditCard={visibleCreditCard}
                  setCardInstallment={setCardInstallment}
                  handleMonthlyFocus={handleMonthlyFocus}
                  creditCardSelected={creditCardSelected}
                  setActiveIndexModal={setActiveIndexModal}
                  setCreditCardClient={setCreditCardClient}
                  optionsInstallments={optionsInstallments}
                  setVisibleCreditCard={setVisibleCreditCard}
                  setCreditCardSelected={setCreditCardSelected}
                  visiblePaymentMethods={visiblePaymentMethods}
                  handleInstallmentFocus={handleInstallmentFocus}
                  handleInstallmentChange={handleInstallmentChange}
                  setVisiblePaymentMethods={setVisiblePaymentMethods}
                  setVisibleModalCreditCard={setVisibleModalCreditCard}
                  handleSelectPaymentMethod={handleSelectPaymentMethod}
                />
              </div>
            )}
          </div>
          <div className="col-xl-3 col-md-5">
            <Resume
              plan={plan}
              form={form}
              cupom={cupom}
              bestDay={bestDay}
              setCupom={setCupom}
              loadingButton={loadingButton}
              handleSubmit={handleSubmit}
              loadingCupom={loadingCupom}
              appliedCoupon={appliedCoupon}
              validateCupom={validateCupom}
              visibleDiscount={visibleDiscount}
              setLoadingCupom={setLoadingCupom}
              setVisibleDiscount={setVisibleDiscount}
            />
          </div>
        </div>
      </div>
      <ModalClientData
        searchDoc
        baseDataForm={baseDataForm}
        activeIndex={activeIndexModal}
        visible={visibleModalCreditCard}
        creditCardClient={creditCardClient}
        setActiveIndex={setActiveIndexModal}
        setVisible={setVisibleModalCreditCard}
        setCreditCardClient={setCreditCardClient}
      />
      <ModalPixPayment
        visible={visiblePixPayment}
        setVisible={setVisiblePixPayment}
        pixDataQR={pixDataQR}
        setPixDataQR={setPixDataQR}
        onContinue={() => {
          localStorage.removeItem("formData");
          navigate("/success", {
            state: {
              pixPayment: true,
              idPayment: pixDataQR?.id ? pixDataQR?.id : "",
            },
          });
        }}
      />
    </>
  );
};

export default Payment;
